import 'css-chunksrc/client/scenes/calendar/week/event/styles.scss';export default {
  "event": "_event_vun65_1",
  "background": "_background_vun65_8",
  "main": "_main_vun65_17",
  "time": "_time_vun65_29",
  "name": "_name_vun65_36",
  "icon": "_icon_vun65_44",
  "taskIcon": "_taskIcon_vun65_54"
};